/**
 * Cartao "Ações" do lead.
 *
 * Um `primary` por bloco (guia, secao 4): "Marcar venda pela vendedora" e a
 * acao que gera receita, entao e ela. "Enviar mensagem manual" leva ao
 * formulario de disparo da administracao -- so `platform_admin` ve, porque
 * disparos sao operados pela equipe do Converte Facil em nome da empresa
 * (decisao do dono, 24/09/2026); o lojista ve uma linha explicando isso.
 * "Remover da régua" e `danger` e pede confirmacao.
 *
 * O link do disparo preserva o periodo do cabecalho e acrescenta `lead=<id>`,
 * por isso monta a busca a mao em vez de usar o `keepSearch` do LinkButton.
 */

import { useLocation } from 'react-router-dom';
import { Badge, Button, Footnote, LinkButton, SectionCard } from '../../../components/ui';

export function CartaoAcoes({
  leadId,
  isPlatformAdmin,
  podeMarcarVenda,
  vendaMarcada,
  rotuloVenda = 'Registrado na prévia',
  podeRemover,
  removida,
  onMarcarVenda,
  onRemover,
}: {
  readonly leadId: string;
  readonly isPlatformAdmin: boolean;
  readonly podeMarcarVenda: boolean;
  readonly vendaMarcada: boolean;
  /** Selo depois da venda: "Registrado na prévia" ou o desfecho vindo do servidor. */
  readonly rotuloVenda?: string;
  readonly podeRemover: boolean;
  readonly removida: boolean;
  readonly onMarcarVenda: () => void;
  readonly onRemover: () => void;
}): JSX.Element {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  params.set('lead', leadId);
  const destinoDisparo = `/admin/disparos/whatsapp?${params.toString()}`;

  return (
    <SectionCard id="acoes-do-lead" title="Ações" icon="disparo">
      <div className="flex flex-col gap-3">
        {isPlatformAdmin ? (
          <LinkButton to={destinoDisparo} keepSearch={false} variant="secondary" size="lg" icon="whatsapp" className="w-full">
            Enviar mensagem manual
          </LinkButton>
        ) : (
          <Footnote>Mensagens manuais são enviadas pela equipe do Converte Fácil em nome da sua empresa.</Footnote>
        )}

        <div className="flex flex-col gap-1.5">
          <Button variant="primary" size="lg" icon="moeda" className="w-full" onClick={onMarcarVenda} disabled={!podeMarcarVenda}>
            Marcar venda pela vendedora
          </Button>
          {vendaMarcada ? (
            <span className="flex justify-center">
              <Badge tone="accent" icon="check">
                {rotuloVenda}
              </Badge>
            </span>
          ) : null}
          {!podeMarcarVenda && !vendaMarcada ? <p className="text-center text-xs text-ink-subtle">Este lead já tem pagamento creditado.</p> : null}
        </div>

        <div className="flex flex-col gap-1.5 border-t border-line pt-3">
          <Button variant="danger" size="lg" icon="x" className="w-full" onClick={onRemover} disabled={!podeRemover}>
            Remover da régua
          </Button>
          {removida ? (
            <span className="flex justify-center">
              <Badge tone="warning" icon="check">
                Removido nesta prévia
              </Badge>
            </span>
          ) : null}
          {!podeRemover && !removida ? <p className="text-center text-xs text-ink-subtle">A régua já terminou para este lead.</p> : null}
        </div>
      </div>
    </SectionCard>
  );
}
